export const OPT_OUT_STATUS_OPTIONS = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
];
// Maps the API sort column ids used by the table to the backend field names.
export const OPT_OUT_SORT_MAP = {
    created_at: "createdAt",
    name: "name",
    email: "email",
};
export function mapContactsFromApi(contacts = []) {
    return (contacts || []).map((c) => ({
        id: c?._id,
        name: c?.name || "",
        email: c?.email || "",
        status: c?.status || "active",
        notes: c?.notes || "",
        created_at: c?.createdAt || "",
        raw: c,
    }));
}
